var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefineMessageUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_559",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#1450ff",
    floodOpacity: 0.208
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162010",
    "data-name": "Group 162010",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559-2",
    "data-name": "Rectangle 559",
    width: 24,
    height: 24,
    rx: 6,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Undo",
    "data-name": "Arrow Undo",
    transform: "translate(4.286 4.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83709",
    "data-name": "Path 83709",
    d: "M9,6.723a.723.723,0,1,1,1.446,0V9.706l2.578-2.578a3.858,3.858,0,1,1,5.455,5.458l-4.773,4.773a.724.724,0,0,1-1.022-1.025l4.773-4.773a2.41,2.41,0,0,0-3.41-3.407l-2.186,2.186h2.2a.723.723,0,1,1,0,1.446H9.82a.819.819,0,0,1-.82-.82Z",
    transform: "translate(-6.59 -4.07)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83710",
    "data-name": "Path 83710",
    d: "M0,0H15.429V15.429H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefineMessageUndoIcon);
export default __webpack_public_path__ + "static/media/refine-message-undo-icon.8f6b18b64390b1db1e8958394711df6a.svg";
export { ForwardRef as ReactComponent };